<template>
    <div>
        <nav class=" bg-base-color" style="padding: 0;text-align: center">
            <div class="d-none d-sm-none d-md-none d-lg-inline-flex" >
                <b-button class="form-control home-button" :pressed="isReport" @click="onReport()">
                    <img style="width: 25px"
                         src="../assets/data-d.png"> ระบบรายงานข้อมูล
                </b-button>
                <b-button class="form-control home-button"  :pressed="isDashboard" @click="onDashboard()">
                    <img style="width: 20px"
                         src="../assets/graph-d.png">
                    รายงานสถานการณ์
                </b-button>
            </div>
        </nav>
        <nav class="bg-base-color d-lg-none d-xl-none" style="padding: 0;text-align: right">
            <b-button v-b-toggle.collapse-1 class="bg-base-color " style="border: 0;">
                <span class="font-default-color" style="font-size: 20px"><i class="fas fa-bars"></i></span>
            </b-button>
        </nav>
        <b-collapse id="collapse-1" class="d-lg-none d-xl-none ">
                <b-button class="form-control home-button" :pressed="isReport" @click="onReport()">
                    <img style="width: 25px"
                         src="../assets/data-d.png"> ระบบรายงานข้อมูล
                </b-button>
                <b-button class="form-control home-button " :pressed="isDashboard" @click="onDashboard()">
                    <img style="width: 20px"
                         src="../assets/graph-d.png">
                    รายงานสถานการณ์
                </b-button>
        </b-collapse>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import moment from "moment";
    import {domain} from "../util/Constants";

    export default {
        name: "Header",
        created() {
            // this.checkLogin();
            this.getCurrentDate();
        },
        computed: {
            ...mapState({
                user_login: state => {
                    return state.Auth.user_login
                },
                form: state => {
                    return state.Event.form;
                },
                form_patient: state => {
                    return state.Patient.form;
                },
            })
        },
        data() {
            return {
                currentDate: "",
                isReport: true,
                isDashboard: false,
            };
        },
        methods: {
            onReport() {
                this.isReport = true;
                this.isDashboard = false;
            },
            onDashboard() {
                this.isReport = false;
                this.isDashboard = true;
            },
            getCurrentDate() {
                this.currentDate = moment().format("YYYY-MM-DD");
            },
            checkLogin() {
                if (this.user_login == null) {
                    this.$router.push({
                        name: "LoginView"
                    });
                }
            },
            goToDrowningForm(event_id, order = "") {
                this.$store.dispatch("Patient/showPatient", {
                    event_id: event_id,
                    order: order

                }).then(() => {
                    if (this.form_patient.id) {
                        this.$router.push({
                            name: "DrowningForm",
                            params: {order},
                        });
                    } else {
                        this.$router.push({
                            name: "DrowningForm",
                            params: {order}
                        })
                        this.$store.dispatch("Patient/clearFormData")
                        this.$store.dispatch("Patient/setOrder", order);
                    }
                })
            },
            printEventPDF(id) {
                window.open(domain + '/event_pdf/' + id, '_blank')
            },
            printPatientPDF(id) {
                window.open(domain + '/event_pdf/' + id, '_blank')
            },
        }
    }
</script>

<style scoped>

    .home-button {
        line-height: 25px;
        font-size: 18px;
        font-weight: bold;
        border-left: 1px solid #B9B9B9;
        border-right: 1px solid #B9B9B9;
        border-top: 0px;
        border-bottom: 0px;
        white-space: nowrap;
        border-radius: 0;
        background: #EFEFEF;
        color: #2DA1A9;
        text-align: center;
    }

</style>
